export const getQaChunksUrl = (workspaceId: string, agentId: string) =>
  `/business/workspaces/${workspaceId}/agents/${agentId}/qa_chunks`;

export const getQaChunkUrl = (workspaceId: string, agentId: string, id: string) =>
  `/business/workspaces/${workspaceId}/agents/${agentId}/qa_chunks/${id}`;

export const getQaChunkImportUrl = (workspaceId: string, agentId: string) =>
  `/business/workspaces/${workspaceId}/agents/${agentId}/qa_chunks/import`;
